import { AlbumResponse } from '@klubovna/api-client';
import { PaginatedResponse } from '@klubovna/api-client';
import { createAction, props } from '@ngrx/store';
import { AlbumsQueryParams } from '../../services/albums.api.service';

export const loadAlbums = createAction('[Albums] Load Albums', props<{ params?: AlbumsQueryParams }>());

export const loadAlbumsSuccess = createAction(
  '[Albums] Load Albums Success',
  props<{ response: PaginatedResponse<AlbumResponse> }>(),
);

export const loadAlbumsFailure = createAction(
  '[Albums] Load Albums Failure',
  props<{ error: string }>(),
);

export const loadMoreAlbums = createAction('[Albums] Load More Albums');

export const loadMoreAlbumsSuccess = createAction(
  '[Albums] Load More Albums Success',
  props<{ response: PaginatedResponse<AlbumResponse> }>(),
);

export const loadMoreAlbumsFailure = createAction(
  '[Albums] Load More Albums Failure',
  props<{ error: string }>(),
);

export const loadAlbumBySlug = createAction('[Albums] Load Album By Slug', props<{ slug: string }>());

export const loadAlbumById = createAction('[Albums] Load Album By Id', props<{ id: string }>());

export const loadAlbumSuccess = createAction(
  '[Albums] Load Album Success',
  props<{ album: AlbumResponse }>(),
);

export const loadAlbumFailure = createAction(
  '[Albums] Load Album Failure',
  props<{ error: string }>(),
);

export const clearSelectedAlbum = createAction('[Albums] Clear Selected Album');

export const resetAlbums = createAction('[Albums] Reset Albums');
